var _circle, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleAnalyticsIcondark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.95384,
    cy: 21.0461,
    r: 2.95384,
    fill: "#8E99A6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.625,
    y: 8.86157,
    width: 5.7846,
    height: 15.1384,
    rx: 2.8923,
    fill: "#8E99A6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1484,
    width: 5.7846,
    height: 24,
    rx: 2.8923,
    fill: "#8E99A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAnalyticsIcondark);
export default __webpack_public_path__ + "static/media/GoogleAnalyticsIcondark.3245aab3690cb79e8aaf05400301aa39.svg";
export { ForwardRef as ReactComponent };